import { IDamageReportReducer } from '../../reducers/damageReportReducer';

const helper = {
	getDamageType: function (damagetype) {
		let result = '';
		switch (damagetype) {
			case 'reportDamage':
				result = 'Tilkynna tjn';
				break;
			case 'shipmentMissing':
				result = 'Gltu sending';
				break;
			case 'itemMissing':
				result = 'Vntun  sendingu';
				break;
			default:
				result = '';
		}
		return result;
	},
};

export const getDamageReportDataModel = (data: IDamageReportReducer) => {
	// fix mapping for server
	let whoFillsOut = '';
	let howToHandle = '';
	let whoToPay = '';
	if (data.stepInfoAboutDamage.whoFillsOut && data.stepInfoAboutDamage.whoFillsOut.value) {
		if (data.stepInfoAboutDamage.whoFillsOut.value === 'sender') {
			whoFillsOut = 'Sender'; // S
		} else if (data.stepInfoAboutDamage.whoFillsOut.value === 'recipient') {
			whoFillsOut = 'Receiver'; // V
		} else {
			whoFillsOut = 'A'; // A email sent
		}
	}
	if (data.stepInfoAboutDamage.howToHandle && data.stepInfoAboutDamage.howToHandle.value) {
		if (data.stepInfoAboutDamage.howToHandle.value === 'sendToUs') {
			howToHandle = 'Send item to claims department'; //1
		} else if (data.stepInfoAboutDamage.howToHandle.value === 'sendToUs') {
			howToHandle = 'Receiver keeps the item'; // 2
		} else if (data.stepInfoAboutDamage.howToHandle.value === 'productWithSender') {
			howToHandle = 'Sender received the item'; // 3
		} else if (data.stepInfoAboutDamage.howToHandle.value === 'senderIsGoingToHoldOnToTheProduct') {
			howToHandle = 'Sender keeps the item'; // 4
		}
	}
	if (data.stepPaymentInfo.whoToPay && data.stepPaymentInfo.whoToPay.value) {
		if (data.stepPaymentInfo.whoToPay.value === 'sender') {
			whoToPay = 'Sender';
		} else if (data.stepPaymentInfo.whoToPay.value === 'recipient') {
			whoToPay = 'Receiver';
		} else {
			whoToPay = 'other';
		}
	}

	const model = {
		Info: {
			Type: helper.getDamageType(data.stepInfoAboutDamage.damageType),
			WhoFillsOut: whoFillsOut, //data.stepInfoAboutDamage.whoFillsOut ? data.stepInfoAboutDamage.whoFillsOut.label : '',
			ReporterName: data.stepInfoAboutDamage.reporterName,
			EmailForCopyOfReport: data.stepInfoAboutDamage.emailForCopyOfReport,
			HowToHandle: howToHandle, //data.stepInfoAboutDamage.howToHandle ? data.stepInfoAboutDamage.howToHandle.label : '',
			Trackingnumber: data.stepInfoAboutDamage.trackingNumber,
			Content: data.stepInfoAboutDamage.content,
			Description: data.stepInfoAboutDamage.description,
		},
		Sender: {
			PersonIsForeign: data.stepInfo.senderIsForeign,
			Name: data.stepInfo.senderName,
			Ssn: data.stepInfo.senderSsn,
			Address: data.stepInfo.senderAddress,
			Zip: data.stepInfo.senderZip ? data.stepInfo.senderZip.value : '',
			Phone: data.stepInfo.senderPhone,
			Email: data.stepInfo.senderEmail,
			Contact: data.stepInfo.senderContact,
			ForeignZip: data.stepInfo.senderIsForeign ? data.stepInfo.senderForeignZip : '',
			ForeignCity: data.stepInfo.senderIsForeign ? data.stepInfo.senderForeignCity : '',
			ForeignCountry: data.stepInfo.senderIsForeign ? data.stepInfo.senderForeignCountry : '',
		},
		Receiver: {
			PersonIsForeign: data.stepInfo.receiverIsForeign,
			Name: data.stepInfo.receiverName,
			Ssn: data.stepInfo.receiverSsn,
			Address: data.stepInfo.receiverAddress,
			Zip: data.stepInfo.receiverZip ? data.stepInfo.receiverZip.value : '',
			Phone: data.stepInfo.receiverPhone,
			Email: data.stepInfo.receiverEmail,
			Contact: data.stepInfo.receiverContact,
			ForeignZip: data.stepInfo.receiverIsForeign ? data.stepInfo.receiverForeignZip : '',
			ForeignCity: data.stepInfo.receiverIsForeign ? data.stepInfo.receiverForeignCity : '',
			ForeignCountry: data.stepInfo.receiverIsForeign ? data.stepInfo.receiverForeignCountry : '',
		},
		PaymentInfo: {
			PayerIsForeign: data.stepPaymentInfo.payerIsForeign,
			WhoToPay: whoToPay, //  data.stepPaymentInfo.whoToPay ? data.stepPaymentInfo.whoToPay.label : '',
			Ssn: data.stepPaymentInfo.ssn,
			Bank: data.stepPaymentInfo.bank,
			AccountType: data.stepPaymentInfo.accountType,
			BankAccount: data.stepPaymentInfo.account,
			Swift: data.stepPaymentInfo.payerIsForeign ? data.stepPaymentInfo.swift : '',
			Iban: data.stepPaymentInfo.payerIsForeign ? data.stepPaymentInfo.iban : '',
		},
		Files: data.stepInfoAboutDamage.addReceipts.length > 0 ? data.stepInfoAboutDamage.addReceipts : null,
		Images: data.stepInfoAboutDamage.addPictures.length > 0 ? data.stepInfoAboutDamage.addPictures : null,
	};

	return model;
};
